import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Check, Lock, ShieldCheck } from 'lucide-react';
import { useCart } from './CartContext';
import { useCurrency } from './CurrencyContext';
const IMAGEN_PRODUCTO_1 = 'https://cdn.magicpatterns.com/uploads/4av2VwMcsBAv8CuYbM2G3G/ChatGPT_Image_7_abr_2026,_09_52_28_a.m..png';
const IMAGEN_PRODUCTO_2 = 'https://cdn.magicpatterns.com/uploads/jFngmN9RaaPohkZdPmkHLk/Sistema_completo_de_panaderia_saludable.png';
const IMAGEN_PRODUCTO_A = 'https://cdn.magicpatterns.com/uploads/1mL6zsWJbbJqS1gcP6MCfn/Recetas_gluten-free_para_ninos_felices.png';
const IMAGEN_PRODUCTO_B = 'https://cdn.magicpatterns.com/uploads/sUwczYKMoPtoy4MXWhyxdB/ChatGPT_Image_10_abr_2026,_09_44_06_p.m..png';
const IMAGEN_PRODUCTO_3 = 'https://cdn.magicpatterns.com/uploads/ts3TDEshxSaGrnjJSyb12V/Domina_la_panaderia_sin_gluten.png';
// Prices
const PRICE_BASE = 12.95;
const PRICE_P2 = 5.0;
const PRICE_PA = 7.0;
const PRICE_PB = 7.0;
const PRICE_P3 = 27.95;
export function CartDrawer() {
  const {
    isCartOpen,
    closeCart
  } = useCart();
  const {
    currency,
    loading: loadingCurrency,
    formatPrice
  } = useCurrency();
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  const [producto2Selected, setProducto2Selected] = useState(true); // Preselected
  const [productoASelected, setProductoASelected] = useState(false); // Not preselected
  const [productoBSelected, setProductoBSelected] = useState(false); // Not preselected
  const [producto3Selected, setProducto3Selected] = useState(false); // Not preselected
  const toggleProducto2 = () => setProducto2Selected(!producto2Selected);
  const toggleProductoA = () => setProductoASelected(!productoASelected);
  const toggleProductoB = () => setProductoBSelected(!productoBSelected);
  const toggleProducto3 = () => setProducto3Selected(!producto3Selected);
  // Dynamic total
  const totalUSD = PRICE_BASE + (producto2Selected ? PRICE_P2 : 0) + (productoASelected ? PRICE_PA : 0) + (productoBSelected ? PRICE_PB : 0) + (producto3Selected ? PRICE_P3 : 0);
  // Dynamic savings
  const totalSavings = 34.05 + (
  // Base savings (47 - 12.95)
  producto2Selected ? 62 : 0) + (
  // 67 - 5
  productoASelected ? 20 : 0) + (
  // 27 - 7
  productoBSelected ? 20 : 0) + (
  // 27 - 7
  producto3Selected ? 169.05 : 0); // 197 - 27.95
  // Dynamic checkout URL
  const getCheckoutUrl = () => {
    const items = ['42280601911381:1']; // Base product always included
    if (producto2Selected) items.push('42391169335381:1');
    if (productoASelected) items.push('42391500456021:1');
    if (productoBSelected) items.push('42391507664981:1');
    if (producto3Selected) items.push('42391174611029:1');
    return `https://recetariosaludable.lat/cart/${items.join(',')}?checkout`;
  };
  useEffect(() => {
    if (!isCartOpen) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, [isCartOpen]);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  const handleCheckout = () => {
    let productName = 'Recetario Sin Gluten';
    const additions = [];
    if (producto2Selected) additions.push('Mejora Inteligente');
    if (productoASelected) additions.push('Recetas Niños');
    if (productoBSelected) additions.push('Panadería Negocio');
    if (producto3Selected) additions.push('Sistema Completo Profesional');
    if (additions.length > 0) {
      productName += ' + ' + additions.join(' + ');
    }
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: productName,
        content_type: 'product',
        value: totalUSD,
        currency: 'USD'
      });
    }
    window.open(getCheckoutUrl(), '_blank');
  };
  return <AnimatePresence data-id="element-6">
      {isCartOpen && <>
          {/* Overlay */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={closeCart} className="fixed inset-0 bg-black/60 z-[99998]" data-id="element-7" />

          {/* Drawer */}
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed right-0 top-0 h-full w-full md:max-w-[450px] bg-[#FDFBF7] text-[#101827] z-[99999] flex flex-col shadow-2xl font-[Montserrat,_sans-serif]" data-id="element-8">
            {/* HEADER */}
            <div className="flex justify-between items-center p-4 bg-white border-b border-[#E8D0B6]" data-id="element-9">
              <span className="font-extrabold text-lg tracking-tight" data-id="element-10">
                Tu Pedido
              </span>
              <button onClick={closeCart} className="p-1.5 hover:bg-gray-100 rounded-full transition-colors text-gray-500" data-id="element-11">
                <X className="w-5 h-5" data-id="element-12" />
              </button>
            </div>

            {/* TIMER */}
            <div className="text-center bg-[#FFD916]/20 py-2.5 text-[#101827] text-sm border-b border-[#FFD916]/30" data-id="element-13">
              <span className="font-medium" data-id="element-14">⏳ Esta oferta termina en</span>{' '}
              <span className="font-black text-[15px]" data-id="element-15">
                {formatTime(timeLeft)}
              </span>
              <p className="text-[10px] text-gray-600 font-semibold mt-0.5" data-id="element-16">
                👉 Después de esto, vuelve a precio normal
              </p>
            </div>

            {/* BODY */}
            <div className="p-4 flex-1 overflow-y-auto space-y-4" data-id="element-17">
              {/* ═══════════════════════════════════════════ */}
              {/* PRODUCTO 1 — BASE (siempre activo) */}
              {/* ═══════════════════════════════════════════ */}
              <div className="bg-white border border-[#E8D0B6] p-4 rounded-xl shadow-sm relative overflow-hidden" data-id="element-18">
                <div className="absolute top-0 left-0 w-1 h-full bg-green-500" data-id="element-19"></div>
                <div className="flex gap-4" data-id="element-20">
                  <img src={IMAGEN_PRODUCTO_1} alt="Recetario Sin Gluten" className="w-20 h-24 object-cover rounded-lg shadow-sm" data-id="element-21" />
                  <div className="flex-1" data-id="element-22">
                    <div className="text-green-600 text-[11px] font-bold flex items-center gap-1 mb-1 uppercase tracking-wider" data-id="element-23">
                      <Check className="w-3.5 h-3.5" data-id="element-24" /> INCLUIDO EN TU PEDIDO
                    </div>
                    <h3 className="text-[15px] font-black leading-tight mb-1" data-id="element-25">
                      📘 Recetario Sin Gluten: 200+ Recetas Que Sí Funcionan
                    </h3>
                    <p className="text-[11px] text-gray-500 font-semibold mb-2" data-id="element-26">
                      Deja de fallar con recetas que no funcionan
                    </p>
                    <ul className="space-y-1 mb-2" data-id="element-27">
                      <li className="text-[11px] text-gray-600 flex items-start gap-1.5 leading-tight" data-id="element-28">
                        <Check className="w-3 h-3 text-green-500 flex-shrink-0 mt-0.5" data-id="element-29" />
                        Recetas probadas paso a paso
                      </li>
                      <li className="text-[11px] text-gray-600 flex items-start gap-1.5 leading-tight" data-id="element-30">
                        <Check className="w-3 h-3 text-green-500 flex-shrink-0 mt-0.5" data-id="element-31" />
                        Ingredientes fáciles de conseguir
                      </li>
                      <li className="text-[11px] text-gray-600 flex items-start gap-1.5 leading-tight" data-id="element-32">
                        <Check className="w-3 h-3 text-green-500 flex-shrink-0 mt-0.5" data-id="element-33" />
                        Resultados desde el primer intento
                      </li>
                    </ul>
                    <div className="font-black text-lg text-[#101827]" data-id="element-34">
                      {formatPrice(PRICE_BASE)}
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center" data-id="element-35">
                <span className="inline-block bg-gray-100 text-gray-500 text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-36">
                  Mejora tu pedido
                </span>
              </div>

              {/* ═══════════════════════════════════════════ */}
              {/* PRODUCTO 2 — ORDER BUMP (preseleccionado) */}
              {/* ═══════════════════════════════════════════ */}
              <div onClick={toggleProducto2} className={`block border-2 p-4 rounded-xl cursor-pointer transition-all relative overflow-hidden ${producto2Selected ? 'border-[#FFD916] bg-[#FFD916]/5 shadow-md' : 'border-[#E8D0B6] bg-white hover:border-[#FFD916]/50'}`} data-id="element-37">
                <div className="absolute top-0 right-0 bg-[#FFD916] text-[#101827] text-[10px] font-black px-3 py-1 rounded-bl-lg uppercase tracking-wider flex items-center gap-1" data-id="element-38">
                  ⭐ MÁS ELEGIDO
                </div>
                <div className="flex gap-4 mt-2" data-id="element-39">
                  <div className="pt-1 flex flex-col items-center gap-1" data-id="element-40">
                    <div className={`w-5 h-5 rounded border flex items-center justify-center transition-colors ${producto2Selected ? 'bg-[#FFD916] border-[#FFD916]' : 'border-gray-300 bg-white'}`} data-id="element-41">
                      {producto2Selected && <Check className="w-3.5 h-3.5 text-[#101827]" data-id="element-42" />}
                    </div>
                    <span className="text-[9px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-43">
                      Añadir
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-44">
                    <h3 className="text-[15px] font-black leading-tight mb-1 pr-20" data-id="element-45">
                      🔥 Mejora Inteligente: Evita Errores Desde el Primer
                      Intento
                    </h3>
                    <p className="text-[12px] font-semibold text-[#D9A441] mb-2" data-id="element-46">
                      Sin esto, es muy probable que falles en tus recetas
                    </p>

                    <div className="flex gap-3 mb-3" data-id="element-47">
                      <img src={IMAGEN_PRODUCTO_2} alt="Mejora Inteligente" className="w-16 h-20 object-cover rounded shadow-sm" data-id="element-48" />
                      <ul className="space-y-1 flex-1" data-id="element-49">
                        <li className="text-[11px] text-gray-600 flex items-start gap-1.5 leading-tight" data-id="element-50">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-51" />
                          Técnicas que mejoran textura y sabor
                        </li>
                        <li className="text-[11px] text-gray-600 flex items-start gap-1.5 leading-tight" data-id="element-52">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-53" />
                          Recetas prácticas para el día a día
                        </li>
                        <li className="text-[11px] text-gray-600 flex items-start gap-1.5 leading-tight" data-id="element-54">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-55" />
                          Cómo gastar menos en ingredientes
                        </li>
                        <li className="text-[11px] text-gray-600 flex items-start gap-1.5 leading-tight" data-id="element-56">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-57" />
                          Evita errores que arruinan tus recetas
                        </li>
                      </ul>
                    </div>

                    <div className="bg-[#FFD916]/10 rounded-lg p-2.5 text-center border border-[#FFD916]/30" data-id="element-58">
                      <p className="text-[11px] text-gray-500 line-through mb-0.5" data-id="element-59">
                        ANTES {formatPrice(67)}
                      </p>
                      <p className="text-[16px] font-black text-[#101827]" data-id="element-60">
                        HOY SOLO +{formatPrice(5)}
                      </p>
                    </div>

                    <p className="text-center text-[10px] text-[#D9A441] font-bold mt-2 tracking-wide" data-id="element-61">
                      ✔ Más del 60% agrega esta mejora
                    </p>
                  </div>
                </div>
              </div>

              {/* ═══════════════════════════════════════════ */}
              {/* PRODUCTO A — NUEVO ORDER BUMP */}
              {/* ═══════════════════════════════════════════ */}
              <div onClick={toggleProductoA} className={`block border-2 p-4 rounded-xl cursor-pointer transition-all relative overflow-hidden ${productoASelected ? 'border-[#FFD916] bg-[#FFD916]/5 shadow-md' : 'border-[#E8D0B6] bg-white hover:border-[#FFD916]/50'}`} data-id="element-62">
                <div className="flex gap-4 mt-1" data-id="element-63">
                  <div className="pt-1 flex flex-col items-center gap-1" data-id="element-64">
                    <div className={`w-5 h-5 rounded border flex items-center justify-center transition-colors ${productoASelected ? 'bg-[#FFD916] border-[#FFD916]' : 'border-gray-300 bg-white'}`} data-id="element-65">
                      {productoASelected && <Check className="w-3.5 h-3.5 text-[#101827]" data-id="element-66" />}
                    </div>
                    <span className="text-[9px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-67">
                      Añadir
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-68">
                    <h3 className="text-[15px] font-black leading-tight mb-1" data-id="element-69">
                      👉 Solución Inmediata: Recetas Sin Gluten para Niños que
                      Sí Comen Sin Quejarse
                    </h3>
                    <p className="text-[12px] font-semibold text-[#D9A441] mb-3" data-id="element-70">
                      👉 Evita peleas en la mesa y haz que tus hijos coman sin
                      rechazar la comida desde el primer intento.
                    </p>

                    <div className="flex gap-3" data-id="element-71">
                      <img src={IMAGEN_PRODUCTO_A} alt="Recetas Niños" className="w-16 h-20 object-cover rounded shadow-sm" data-id="element-72" />
                      <div className="flex-1 flex flex-col justify-center" data-id="element-73">
                        <div className="bg-[#FFD916]/10 rounded-lg p-2.5 text-center border border-[#FFD916]/30" data-id="element-74">
                          <p className="text-[11px] text-gray-500 line-through mb-0.5" data-id="element-75">
                            ANTES {formatPrice(27)}
                          </p>
                          <p className="text-[16px] font-black text-[#101827]" data-id="element-76">
                            HOY SOLO +{formatPrice(7)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ═══════════════════════════════════════════ */}
              {/* PRODUCTO B — NUEVO ORDER BUMP */}
              {/* ═══════════════════════════════════════════ */}
              <div onClick={toggleProductoB} className={`block border-2 p-4 rounded-xl cursor-pointer transition-all relative overflow-hidden ${productoBSelected ? 'border-[#FFD916] bg-[#FFD916]/5 shadow-md' : 'border-[#E8D0B6] bg-white hover:border-[#FFD916]/50'}`} data-id="element-77">
                <div className="flex gap-4 mt-1" data-id="element-78">
                  <div className="pt-1 flex flex-col items-center gap-1" data-id="element-79">
                    <div className={`w-5 h-5 rounded border flex items-center justify-center transition-colors ${productoBSelected ? 'bg-[#FFD916] border-[#FFD916]' : 'border-gray-300 bg-white'}`} data-id="element-80">
                      {productoBSelected && <Check className="w-3.5 h-3.5 text-[#101827]" data-id="element-81" />}
                    </div>
                    <span className="text-[9px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-82">
                      Añadir
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-83">
                    <h3 className="text-[15px] font-black leading-tight mb-1" data-id="element-84">
                      👉 De Gasto a Ingreso: Convierte tu Panadería Sin Gluten
                      en Dinero Desde Casa
                    </h3>
                    <p className="text-[12px] font-semibold text-[#D9A441] mb-3" data-id="element-85">
                      👉 Aprende a generar ingresos desde casa vendiendo
                      panadería sin gluten, incluso si empiezas desde cero.
                    </p>

                    <div className="flex gap-3" data-id="element-86">
                      <img src={IMAGEN_PRODUCTO_B} alt="Panadería Negocio" className="w-16 h-20 object-cover rounded shadow-sm" data-id="element-87" />
                      <div className="flex-1 flex flex-col justify-center" data-id="element-88">
                        <div className="bg-[#FFD916]/10 rounded-lg p-2.5 text-center border border-[#FFD916]/30" data-id="element-89">
                          <p className="text-[11px] text-gray-500 line-through mb-0.5" data-id="element-90">
                            ANTES {formatPrice(27)}
                          </p>
                          <p className="text-[16px] font-black text-[#101827]" data-id="element-91">
                            HOY SOLO +{formatPrice(7)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ═══════════════════════════════════════════ */}
              {/* PRODUCTO 3 — UPSELL PREMIUM (no preseleccionado) */}
              {/* ═══════════════════════════════════════════ */}
              <div onClick={toggleProducto3} className={`block border-2 p-5 rounded-xl cursor-pointer transition-all relative overflow-hidden ${producto3Selected ? 'border-[#C9A227] bg-[#FFFDF5] shadow-[0_8px_30px_rgba(0,0,0,0.12)]' : 'border-[#D9A441]/40 bg-white hover:border-[#D9A441] shadow-[0_4px_20px_rgba(0,0,0,0.08)]'}`} data-id="element-92">
                <div className="absolute top-0 right-0 bg-gradient-to-r from-[#C9A227] to-[#D9A441] text-white text-[10px] font-black px-3.5 py-1.5 rounded-bl-lg uppercase tracking-wider flex items-center gap-1" data-id="element-93">
                  👑 MEJOR VALOR
                </div>
                <div className="flex gap-4 mt-3" data-id="element-94">
                  <div className="pt-1 flex flex-col items-center gap-1" data-id="element-95">
                    <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${producto3Selected ? 'bg-[#101827] border-[#101827]' : 'border-gray-300 bg-white'}`} data-id="element-96">
                      {producto3Selected && <Check className="w-3.5 h-3.5 text-white" data-id="element-97" />}
                    </div>
                    <span className="text-[9px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-98">
                      Añadir
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-99">
                    <h3 className="text-[16px] font-black leading-tight mb-1.5 pr-24" data-id="element-100">
                      👑 Sistema Completo de Panadería Sin Gluten (Nivel
                      Profesional)
                    </h3>
                    <p className="text-[12px] font-semibold text-[#D9A441] mb-3" data-id="element-101">
                      Todo incluido. Sin prueba y error. Resultados desde el
                      primer intento
                    </p>

                    <div className="flex gap-3 mb-3" data-id="element-102">
                      <img src={IMAGEN_PRODUCTO_3} alt="Sistema Completo Profesional" className="w-16 h-20 object-cover rounded shadow-sm" data-id="element-103" />
                      <ul className="space-y-1.5 flex-1" data-id="element-104">
                        <li className="text-[11px] text-gray-700 flex items-start gap-1.5 leading-tight font-bold" data-id="element-105">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-106" />
                          Incluye TODO lo anterior + el sistema completo para
                          dejar de fallar desde el primer intento
                        </li>
                        <li className="text-[11px] text-gray-700 flex items-start gap-1.5 leading-tight font-medium" data-id="element-107">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-108" />
                          Plan paso a paso de 30 días
                        </li>
                        <li className="text-[11px] text-gray-700 flex items-start gap-1.5 leading-tight font-medium" data-id="element-109">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-110" />
                          Sistema completo sin improvisar
                        </li>
                        <li className="text-[11px] text-gray-700 flex items-start gap-1.5 leading-tight font-medium" data-id="element-111">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-112" />
                          Evita errores comunes
                        </li>
                        <li className="text-[11px] text-gray-700 flex items-start gap-1.5 leading-tight font-medium" data-id="element-113">
                          <Check className="w-3 h-3 text-[#D9A441] flex-shrink-0 mt-0.5" data-id="element-114" />
                          Resultados nivel profesional
                        </li>
                      </ul>
                    </div>

                    <div className="bg-[#FFFDF5] rounded-lg p-3 text-center border border-[#D9A441]/30" data-id="element-115">
                      <p className="text-[11px] text-gray-500 line-through mb-0.5" data-id="element-116">
                        ANTES {formatPrice(197)}
                      </p>
                      <p className="text-[18px] font-black text-[#101827]" data-id="element-117">
                        HOY $45.95
                      </p>
                      <p className="text-[10px] text-gray-500 font-semibold mt-1 tracking-wide" data-id="element-118">
                        Pago único — acceso de por vida
                      </p>
                    </div>

                    <p className="text-center text-[10px] text-[#D9A441] font-bold mt-2.5 tracking-wide" data-id="element-119">
                      ✅ Más del 70% de los usuarios eligen esta opción
                    </p>
                    <p className="text-center text-[10px] text-[#D9A441]/80 font-semibold mt-1 tracking-wide" data-id="element-120">
                      ✔ La opción más inteligente si quieres hacerlo bien desde
                      el inicio
                    </p>
                  </div>
                </div>
              </div>

              {/* Bottom spacer */}
              <div className="h-4" data-id="element-121"></div>
            </div>

            {/* FOOTER */}
            <div className="p-5 bg-white border-t border-[#E8D0B6] shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" data-id="element-122">
              <div className="flex justify-between items-end mb-4" data-id="element-123">
                <div className="flex flex-col" data-id="element-124">
                  <span className="text-gray-500 font-bold text-sm uppercase tracking-wider" data-id="element-125">
                    🔒 Total de tu acceso hoy:
                  </span>
                  <AnimatePresence mode="wait" data-id="element-126">
                    <motion.div key={totalSavings} initial={{
                  opacity: 0,
                  y: -5
                }} animate={{
                  opacity: 1,
                  y: 0
                }} className="mt-1.5" data-id="element-127">
                      <span className="bg-green-100 text-green-700 text-[11px] font-bold px-2 py-1 rounded-md border border-green-200" data-id="element-128">
                        ¡Ahorras {formatPrice(totalSavings)}!
                      </span>
                    </motion.div>
                  </AnimatePresence>
                </div>
                <div className="text-right" data-id="element-129">
                  <span className="text-3xl font-black text-[#101827] leading-none" data-id="element-130">
                    {formatPrice(totalUSD)}
                  </span>
                  {!loadingCurrency && currency.code !== 'USD' && <p className="text-[10px] text-gray-400 mt-1" data-id="element-131">
                      Aprox. ${totalUSD.toFixed(2)} USD
                    </p>}
                </div>
              </div>

              <button onClick={handleCheckout} className="w-full bg-[#FFD916] hover:bg-[#f0cc15] text-[#101827] font-black text-lg py-4 rounded-xl shadow-[0_4px_14px_rgba(255,217,22,0.4)] hover:shadow-[0_6px_20px_rgba(255,217,22,0.5)] transition-all flex items-center justify-center gap-2 hover:-translate-y-0.5" data-id="element-132">
                <Lock className="w-5 h-5" data-id="element-133" />
                COMPLETAR COMPRA
              </button>

              {/* Trust triggers */}
              <div className="flex items-center justify-center gap-3 mt-3 text-[11px] text-gray-500 font-medium" data-id="element-134">
                <span className="flex items-center gap-1" data-id="element-135">
                  <Check className="w-3.5 h-3.5 text-green-500" data-id="element-136" /> Acceso
                  inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-137">
                  <ShieldCheck className="w-3.5 h-3.5 text-green-500" data-id="element-138" /> Pago
                  100% seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-139">
                  <Check className="w-3.5 h-3.5 text-green-500" data-id="element-140" /> Garantía de 7
                  días
                </span>
              </div>

              <p className="text-center text-[11px] text-[#D9A441] font-bold mt-3 tracking-wide" data-id="element-141">
                👉 Estás a un paso de dejar de fallar en la cocina
              </p>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}